<div *ngIf="isTyping" class="typing secondary-text">typing<span class="dots-cont ml-8">
    <span class="dot dot-1"></span>
    <span class="dot dot-2"></span>
    <span class="dot dot-3"></span>
</span></div>
